const mainline = {
  "sourceNotFound": "The source document was not found. Select an available document.",
  "sourceForbidden": "You do not have permission to read this source document.",
  "sourceFormatUnsupported": "Use PDF, PPTX, XLSX or ordinary DOCX text with matching file metadata. DOC and DOCM are unsupported.",
  "sourceExtractionPending": "Extraction is pending. Wait for completion before selecting this source.",
  "sourceExtractionFailed": "Extraction failed. Reprocess the document before using it as a source.",
  "sourceTextEmpty": "No usable body text was extracted. Check the document or use pasted text.",
  "sourceTooLarge": "This source exceeds 100,000 characters. Split it before analysis; it will not be truncated.",

  "comparisonTooLarge": "The comparison input exceeds the processing limit. Split the source, save it, and try again. Your saved rows are preserved.",
  "extractionMode": "Change extraction mode",
  "focused": "Major changes (up to 10)",
  "exhaustive": "All changes (exhaustive)",
  "extractionModeHint": "Applies to old/new specifications. Saving this setting does not run AI. Ten is the limit for one AI presentation, not for manual entries or saved rows.",
  "exhaustiveHint": "Exhaustive extraction can take longer. It covers the available input scope, not every real-world change. If a processing limit is reached, split the source and try again.",
  "exhaustiveWorking": "Working… Exhaustive extraction may take longer. Saved rows are preserved.",
  "savedExtractionMode": "Next extraction setting",
  "extractAdditional": "Extract additional changes exhaustively",
  "lastExtraction": "Previous extraction: {{mode}}, {{count}} candidates (old {{old}} / new {{new}} characters). This is separate from saved or accepted counts.",
  "extractionCompleted": "Extraction completed: {{mode}}, {{count}} candidates (not yet applied to saved rows)",
  "extractionReviewHint": "Duplicates are not added. For similar saved rows, skip, add separately, or explicitly update a selected row. Other manual entries and decisions are preserved.",
  "comparisonCharacters": "Compared input: old {{old}} / new {{new}} characters",
  "match_new": "New candidate",
  "match_duplicate": "Same saved content and evidence (no duplicate addition)",
  "match_possible_match": "Similar saved rows found. Compare their content and decisions.",
  "candidateAction": "Candidate action",
  "keepExisting": "Skip this candidate (keep existing rows)",
  "addCandidate": "Add as a new row",
  "updateCandidate": "Update the selected saved row",

  "temporarilyUnavailable": "Temporarily unavailable. Your input is preserved. Wait briefly, then retry the same operation.",
  "saveInputsFirst": "Save your changed inputs before reviewing, using AI or exporting.",
  "applyReason": "Reason for applying (defaults to the proposal reason)",
  "comparisonScope": "This comparison used the old and new specifications. Selected references and extra conditions are used for downstream generation and reconsideration.",
  "documentNotReady": "Document text is not available yet. Wait for extraction or switch to pasted text.",
  "textReady": "Text available",
  "textNotReady": "Text unavailable; pasted input is supported",
  "titleMatch": "Candidate reason: title matches the search term",
  "recentCandidate": "Candidate reason: recently updated tenant document",
  "confirmScores": "Confirm saved S/O/D values with this review decision",
  "blocker_design_change_missing": "Add a design change",
  "blocker_design_change_review": "Review the design change",
  "blocker_failure_mode_coverage": "Accepted change needs a failure mode",
  "blocker_failure_mode_review": "Review the failure mode",
  "blocker_failure_mode_structure": "Enter failure, cause and effect",
  "blocker_countermeasure_review": "Review the countermeasure",
  "blocker_countermeasure_reason": "Explain why no countermeasure is needed",
  "blocker_countermeasure_coverage": "Decide whether a countermeasure is required and accept one if needed",
  "blocker_countermeasure_mechanism": "Enter target cause and mechanism",
  "blocker_countermeasure_verification": "Enter verification method and acceptance criteria",
  "blocker_needs_recheck": "Reconfirm after input or parent changes",
  "blocker_unknown_conditions": "Unconfirmed conditions remain",
  "blocker_score_review": "S/O/D values need review",
  "blocker_input_condition": "Confirm material, dimensions, operating conditions and selected references",
  "blocker_reference_unavailable": "A selected document has unread content",
  "open": "Enter and review",
  "normalView": "View results",
  "progress": "Materials and conditions → Changes → Failure modes → Countermeasures → Review and export",
  "inputs": "Materials and conditions",
  "target": "Target component / function",
  "pattern": "Input method",
  "old_new_documents": "Old and new specifications",
  "old_requirements": "Old specification and new requirements",
  "change_report": "Change / DR report",
  "manual": "Manual input",
  "import": "Imported",
  "ai": "AI generated",
  "legacy": "Legacy (origin unrecorded)",
  "old_text": "Old specification",
  "new_text": "New specification",
  "report_text": "Report text",
  "requirements": "New requirements",
  "requirementsHint": "AI proposes changes to meet requirements. Review these as proposals, separate from confirmed specification differences.",
  "registeredDocument": "Registered document (search candidates first)",
  "pastedText": "Use pasted text",
  "references": "Search and select reference candidates",
  "searchQuery": "Document title search",
  "search": "Search / search again",
  "searchFailed": "Could not load candidates. Please search again.",
  "searchScope": "Searches document titles in this tenant. Check titles and update dates before selecting references.",
  "selectedCount": "{{count}} selected references",
  "characters": "characters",
  "more": "Load more",
  "material": "Material (leave blank if unknown)",
  "dimensions": "Dimensions (leave blank if unknown)",
  "operating_conditions": "Operating conditions (leave blank if unknown)",
  "constraints": "Constraints / notes",
  "conditionsHint": "Blank material, dimensions or operating conditions remain unconfirmed. Explain any condition that does not apply.",
  "saveInputs": "Save materials and conditions (without AI)",
  "actualScope": "Saved reference scope",
  "partial": "Partially referenced",
  "evidence": "Evidence / research notes",
  "sourceKind": "Information type",
  "input_fact": "Input fact",
  "internal_document": "Internal document",
  "public_information": "Public information note",
  "ai_assumption": "AI assumption",
  "sourceTitle": "Source title",
  "quote": "Quote / content",
  "retrievedOn": "Retrieved on",
  "applicability": "Applicability",
  "addEvidence": "Add evidence",
  "remove": "Remove",
  "webHint": "Imports research notes. No automatic web search is performed. Save to persist changes.",
  "design_change": "Design changes",
  "failure_mode": "Failure modes",
  "countermeasure": "Countermeasures",
  "category": "Category",
  "item_name": "Component / function",
  "old_specification": "Previous state",
  "new_specification": "New state / requirement",
  "change_description": "Change and reason",
  "failure_description": "Failure description",
  "failure_cause": "Cause",
  "failure_effect": "Effect",
  "causal_claims": "Causal hypothesis assembled by AI",
  "noCausalClaims": "No causal claims",
  "evidence_direct": "Direct evidence",
  "evidence_supported": "Supporting evidence",
  "evidence_assumption": "Assumption",
  "scoreResetWarning": "Saving this change returns the reviewed RPN to provisional. It will need review again.",
  "scoreResetAcknowledge": "I understand the RPN returns to provisional",
  "severity_score": "S (severity, optional)",
  "occurrence_score": "O (occurrence, optional)",
  "detection_score": "D (detection, optional)",
  "countermeasure_requirement": "Countermeasure requirement",
  "countermeasure_not_required_reason": "Reason no countermeasure is required",
  "pending": "Undecided",
  "required": "Required",
  "not_required": "Not required",
  "description": "Countermeasure description",
  "countermeasure_type": "Countermeasure type",
  "prevention": "Prevention",
  "detection": "Detection",
  "mitigation": "Mitigation",
  "target_cause": "Target cause",
  "mechanism": "Mechanism",
  "verification_method": "Verification method",
  "acceptance_criteria": "Acceptance criteria",
  "humanOnlyRefused": "This AI proposal contains fields only a person decides (S/O/D, score status, countermeasure requirement and its reason), so it was not applied. Discard it and create a new one.",
  "proposalContext": "Proposal context — not applied to the row",
  "proposalContextConditions": "Unknown conditions the AI raised",
  "proposalContextEvidence": "Evidence the AI cited",
  "proposalContextNone": "None",
  "unknown": "Unknown conditions / assumptions (one per line)",
  "scoreHint": "S/O/D are optional. Saving does not confirm scores or RPN.",
  "parent": "Parent",
  "selectParent": "Select a parent",
  "importParent": "Parent created by this import",
  "add": "Add manually",
  "save": "Save edits",
  "closeEditor": "Close editor",
  "editReview": "Edit / review",
  "generate": "Generate AI candidates",
  "reason": "Decision / change reason",
  "reviewSavedHint": "Review decisions and AI reconsideration use saved values. Save edits first.",
  "reconfirm": "I rechecked the impact of parent / condition changes",
  "accepted": "Accepted",
  "modified": "Accepted with changes",
  "deferred": "Deferred",
  "rejected": "Rejected",
  "ai_candidate": "Unreviewed",
  "needs_info": "Needs information",
  "superseded": "Superseded",
  "recheck": "Needs reconfirmation",
  "revisionInstruction": "Instructions for AI reconsideration",
  "reconsider": "Ask AI to reconsider",
  "execution": "Execution",
  "verification": "Verification",
  "not_started": "Not executed",
  "completed": "Execution completed",
  "not_verified": "Not verified",
  "verified": "Verification completed",
  "owner": "Owner (optional)",
  "dueDate": "Due date (optional)",
  "counts": "Total {{total}} / filtered {{filtered}}",
  "filter": "Display filter",
  "all": "All rows",
  "pageSize": "Rows per page",
  "previous": "Previous",
  "next": "Next",
  "proposedChange": "Proposed requirement change",
  "unconfirmed": "Unconfirmed",
  "preview": "Unapplied candidate preview",
  "stalePreview": "Inputs or decisions changed. Discard this stale preview and generate another.",
  "before": "Current",
  "after": "Proposed",
  "confirmParents": "I checked candidate content and parent relationships",
  "orphanHint": "Some rows have no parent. Select one, or discard this preview, save a new parent manually and import again.",
  "inputOnly": "Entered materials and conditions only",
  "apply": "Apply selected changes / candidates",
  "discard": "Discard preview",
  "importPreview": "Preview report import",
  "loadFailed": "Could not load saved data. Open the session again from history.",
  "conflict": "Another edit was saved. Your inputs remain. Reload the current state before retrying.",
  "validationFailed": "Check the fields, parents and reconfirmation. Registered documents need extracted text. Your inputs remain.",
  "commandFailed": "The operation failed. Saved inputs remain. You can retry the same operation.",
  "reviewTextRequired": "Fill in {{fields}} before accepting this row. Your inputs remain.",
  "notRequiredReasonRequired": "Enter why no countermeasure is required before accepting. Your inputs remain.",
  "reviewedScoresRequired": "Reviewed scoring needs the occurrence and detection scores. Your inputs remain.",
  "extractionIntegrityHeld": "This change has unresolved extraction integrity issues. Resolve them before accepting.",
  "rowNotFound": "The row or the session was not found. Reload the current state.",
  "supplementCopied": "The AI copied your supplement text into a candidate, so nothing was saved. Generate again; if it repeats, rephrase the supplement.",
  "analysisInProgress": "Not done: this session is being analyzed. Try again after the analysis finishes. Your inputs remain.",
  "fieldSeparator": ", ",
  "readOnly": "Mainline editing is disabled. Saved results remain readable.",
  "statusChecking": "Checking whether mainline editing is available…",
  "statusUnavailable": "Couldn't confirm whether mainline editing is available. Saved results are shown read-only; reload the page to try again.",
  "working": "Working…",
  "reload": "Reload current state",
  "retry": "Retry the same operation",
  "export": "Review / Excel export",
  "draft": "Draft",
  "content_reviewed": "Content reviewed",
  "scored": "Scores reviewed",
  "blockers": "{{count}} unresolved",
  "exportScope": "Export scope",
  "acceptedScope": "Accepted / accepted with changes",
  "exportHint": "Excel is independent of the displayed page and filter. Unconfirmed conditions or reconfirmation require a draft export.",
  "export_draft": "Draft Excel",
  "export_reviewed": "Content reviewed Excel",
  "export_scored": "Scored Excel",
  "history": "Save / decision history"
};
export default mainline;
